<template>
    <div class="top">
        <div class="top-c">
            <div style="" class="call-me">联系我们
                <div class="call-me-son">
                    <div style="width:121px;height:12px;line-height:12px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(51,51,51,1);margin-top:38px;margin-left:42px;">电话：400-1858-365</div>
                    <div style="height:12px;width:100%;line-height:12px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(51,51,51,1);padding-left:42px;margin-top:10px;">邮箱：yunpingtai@qcwlcloud.com</div>
                </div>
            </div>
            <img src="../../static/common/callme.png" alt="" style="display:block;float:left;width:14px;height:14px;margin:14px 0 0 10px;">
            <div style="float:right;margin-right:30px;" v-show="!tokenCheck">
                <div style="height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);padding-left:10px;float:left;cursor: pointer;" @click="login()">登录</div>
                <div style="height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);float:left;padding-left:10px;">|</div>
                <div style="height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);padding-left:10px;float:left;cursor: pointer;" @click="register()">注册</div>
            </div>
            <div style="float:right;margin-right:30px;" v-show="tokenCheck">
                <div style="height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);padding-left:10px;float:left;cursor: pointer;" @click="toMe()">{{account}}</div>
                <div style="height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);float:left;padding-left:10px;">|</div>
                <div style="height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);padding-left:10px;float:left;cursor: pointer;" @click="quit()">退出</div>
            </div>
        </div>   
    </div>
</template>

<script>
    export default {
        name: "top",
         data () {
            return {
                tokenCheck:false,
                account: localStorage.getItem('account')
            };
        },
        props: ["token"],
        watch:{
            token(newVal,oldVal){
                console.log(newVal,oldVal,77);
                if(newVal){
                    this.tokenCheck = true;
                    this.tabIndex = 1;
                }
            },
        },
        methods:{
            login(){
                this.$router.push({
                    path: '/login',
                })
            },
            register(){
                this.$emit('event',false);
                this.$router.push({
                    path: '/register',
                })
            },
            quit(){
                localStorage.removeItem('token')  //删除key以及key中的内容
                localStorage.removeItem('account')
                this.tokenCheck = false;
                this.$router.push({
                    path: '/login',
                })
            },
            complete(){
                this.$router.push({
                    path: '/completeinfor',
                })
            },
            // toMe(){
            //     this.$router.push({
            //         path: '/me',
            //     })
            // },
            decide(){
                if(localStorage.usMobile){
                    this.$router.push({name:'people'})
                }
                else{
                    alert("您还没有登陆，请先登录！");
                    this.$router.push({name:'passwordLogin'})
                }
            },
			toVideoClass(s){
                this.$emit('event1',s)
                sessionStorage.setItem('tabIndex',3);
                this.$router.push({
                    path: '/videoclass',
                    query: {
                        catalogueId: s
                    }
                })
            },
            toMe(){
                sessionStorage.setItem('tabIndex',0);
                this.$router.push({
                    path: '/me',
                    query: {}
                })
            },
           
           
            
        },
        created(){
            let storage = sessionStorage.getItem('tabIndex');
            if(storage){
                this.tabIndex = storage;
            }

            //是否有token
            if(localStorage.token){
                this.tokenCheck = true;
                // this.headImg = localStorage.headImg;
                // this.mobile = localStorage.mobile;
            }else{
                this.tokenCheck = false;
            }

            //判断是否登录
            // this.$axios.get("/v1/muke/student/personal/verifyLogin")
            // .then(({data})=>{
            //     if(data.code == 203){
            //         localStorage.removeItem('token')  
            //         this.tokenCheck = false;
            //     }
            // })
        },
        mounted() {           
            
        }
        
    }
</script>

<style scoped lang="less">  
    .top{
        width:100%;height:40px;background:black;
        .top-c{
            width:1200px;height:40px;margin:0 auto;
            .call-me{
                height:40px;line-height:40px;font-size:12px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);padding-left:30px;float:left;cursor: pointer;position: relative;
                .call-me-son{
                    width:280px;height:125px;background:url(../../static/common/bg.png);
                    position:absolute;top:11px;left:-8px;display:none;z-index:66;
                }
            }
            .call-me:hover .call-me-son{display:block;}
        }
    }


</style>